<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <v-layout class="justify-space-around mt-2 pb-2 pr-2 pl-0" row>
      <MapContainer>
        <WorldMap_MPMC/>
      </MapContainer>

      <v-flex v-show="!$store.state.app.big_map" class="mt-2" lg7 md12 sm12 xl6>
        <top-summary-results class="mb-2"/>
        <!--        <div>-->
        <!--          {{ this.$store.state.user.userServerInfo.subscriptions[0] }}-->
        <!--        </div>-->
        <div class="">
          <v-layout row>
            <v-flex class="xs12 sm12 lg12">
              <div class="body-2 font-weight-bold nav nav-tabs">
                <!-- /.tabrow -->
                <li class="">
                  <a class="disabled"
                  >Details ({{ $store.getters.selectionCounts.results.markets_count }}
                    target markets x
                    {{ $store.getters.selectionCounts.results.products_count }}
                    product)
                    <help-link help_id="16" style="float: right"/>
                  </a>
                </li>
              </div>
            </v-flex>
          </v-layout>

          <div class="tab-content">
            <div class="tab-pane active white">
              <v-container fluid>
                <v-layout class="justify-space-between mt-0 ml-2 mr-1 black--text" row>
                  <v-flex sm12 class="mb-1">
                    <applied_filters_box class="mr-3 mb-1 ml-0"></applied_filters_box>
                  </v-flex>
                  <v-flex class="mb-2">
                    <countries_filtered_box></countries_filtered_box>
                  </v-flex>
                  <v-flex class="sm12 ml-1 mt-1">
                    <products_filtered_box></products_filtered_box>
                  </v-flex>
                  <hr/>

                  <!--                  start-->
                  <v-flex sm12 class="mb-1">
                    <v-layout row>
                      <v-flex class="xs12 sm12 lg12">
                        <div class="body-2 font-weight-bold nav nav-tabs mt-2">
                          <li>
                            <a
                            >Home market export characteristics for product
                              <help-link help_id="13" style="float: right" class="ml-1"/>
                              <v-btn
                                  v-if="!all_open_selection"
                                  class="white--text mr-0 pr-0"
                                  style="float: right"
                                  text
                                  x-small
                                  @click="all_open_selection = true"
                              >
                                <v-icon v-if="!all_open_selection">
                                  mdi-chevron-triple-down
                                </v-icon>
                              </v-btn>
                              <v-btn
                                  v-if="all_open_selection"
                                  class="white--text mr-0 pr-0"
                                  style="float: right"
                                  text
                                  x-small
                                  @click="all_open_selection = false"
                              >
                                <v-icon v-if="all_open_selection">
                                  mdi-chevron-triple-up
                                </v-icon>
                              </v-btn>
                            </a>
                          </li>
                        </div>
                      </v-flex>
                    </v-layout>
                    <div class="tab-content">
                      <div class="tab-pane active white black--text pl-3">
                        <v-container fluid>
                          <result_hover
                              :all_open="all_open_selection"
                              :explanation="
                              $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                                .export_characteristics.REO_F4_1_Text
                            "
                              :result="
                              `${get_yes_no(
                                $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                                  .export_characteristics.REO_F4_1_Result,
                              )} <span class='ml-2 green--text rca_rta_text'>${share_text()}</span>`
                            "
                              heading="Home market is comparatively large exporter of product? [F4.1]"
                          ></result_hover>

                          <result_hover
                              :all_open="all_open_selection"
                              :explanation="
                              $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                                .export_characteristics.REO_F4_2_Text
                            "
                              :result="
                              `${get_yes_no(
                                $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                                  .export_characteristics.REO_F4_2_Result,
                              )} <span class='ml-2 green--text rta_rta_text'>${rta_text()}</span>`
                            "
                              heading="Home market has product export production capacity? [F4.2]"
                          ></result_hover>
                        </v-container>
                      </div>
                    </div>
                  </v-flex>
                  <!--                  stop-->
                </v-layout>

                <v-layout class="justify-space-between mt-0 ml-2 mr-1 black--text" row>
                  <v-flex sm12>
                    <v-card
                        v-if="
                        !this.$store.state.tradeDSM.loading_indicator &&
                          $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                            .query_results.cube.length > 0
                      "
                        class="pt-2"
                    >
                      <v-tabs
                          v-model="country_tabs"
                          active-class="trade-blue"
                          background-color="tab_header_color"
                          slider-color="green"
                          dark
                          dense
                      >
                        <v-tab> Countries</v-tab>
                        <v-tab> Sub-Region</v-tab>
                        <v-tab> Main-Region</v-tab>
                        <v-tab-item>
                          <v-card flat>
                            <v-layout class="pa-2" row>
                              <v-flex>
                                <reo_table_markets cube="cube" table_id="reo_country"/>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-layout class="pa-2" row>
                            <v-flex>
                              <reo_table_markets
                                  cube="cube_C_Region"
                                  table_id="reo_region"
                              />
                            </v-flex>
                          </v-layout>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card flat>
                            <v-layout class="pa-2" row>
                              <v-flex>
                                <reo_table_markets
                                    cube="cube_Main_Region"
                                    table_id="reo_main_region"
                                />
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-tab-item>
                      </v-tabs>
                    </v-card>
                    <template v-else>
                      <v-skeleton-loader
                          v-if="$store.state.tradeDSM.loading_indicator"
                          class="mt-3 mb-4"
                          type="article, actions"
                      ></v-skeleton-loader>
                    </template>
                  </v-flex>
                  <v-layout v-if="!is_run_cube_valid">
                    <reoFrontendTable cube_name="cube"></reoFrontendTable>
                  </v-layout>
                </v-layout>
              </v-container>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <v-layout
        v-if="
        !$store.state.tradeDSM.loading_indicator &&
          $store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.cube
            .length > 0
      "
        row
    >
      <v-flex>
        <tabbed_graph_view
            caption="Trade statistics and trends"
            help_id="8"
        ></tabbed_graph_view>
      </v-flex>
      <v-flex>
        <div class="outline ml-10 mr-10">
          <reoFrontendTable cube_name="cube"></reoFrontendTable>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import TopSummaryResults from '@/components/trade-dsm-application/result-components/top-summary-results';
import WorldMap_MPMC from '@/components/trade-dsm-application/graphs/mpmc/world-map-mpmc';
import countries_filtered_box from '@/components/trade-dsm-application/results-pages/markets-filters-box';
import products_filtered_box from '@/components/trade-dsm-application/results-pages/products-filter-box';
import MapContainer from '@/components/trade-dsm-application/result-components/helpers/map-container';
import reo_table_markets from '@/components/trade-dsm-application/results-pages/tabs/reo_table_markets';
import applied_filters_box from '@/components/trade-dsm-application/results-pages/applied-filters-box';
import result_hover from '@/components/trade-dsm-application/result-components/helpers/result-hover';
import helpLink from '@/components/application-level/help-system/help-link';
import reoFrontendTable from '@/components/trade-dsm-application/result-components/reo_table/reo-frontend-table';
import tabbed_graph_view from '@/components/trade-dsm-application/results-pages/tabs/tabbed_graph_view.vue';

export default {
  name: 'tab1pmc',
  components: {
    tabbed_graph_view,
    reo_table_markets,
    TopSummaryResults,
    WorldMap_MPMC,
    countries_filtered_box,
    products_filtered_box,
    MapContainer,
    applied_filters_box,
    result_hover,
    helpLink,
    reoFrontendTable,
  },
  props: {
    cube: {},
    cube_C_Region: {},
    cube_Main_Region: {},
    cube_Trade_Block: {},
    map_rerender_workarount: {},
  },
  data() {
    return {
      tab_num: 0,
      country_tabs: 0,
      all_open_selection: false,
    };
  },
  mounted() {
    // this.map_rerender_workarount =1
    // window.onresize = () => this.map_rerender_workarount+=1
  },
  methods: {
    rta_text() {
      let s = '';
      s += 'RTA: ';
      s += this.$store.state.tradeDSM.dsm_filter_setttings.Filters.F4.entries[4].max.toFixed(
          4,
      );
      return s;
    },
    share_text() {
      let s = '';

      s += 'RCA: ';
      s += this.$store.state.tradeDSM.dsm_filter_setttings.Filters.F4.entries[2].max.toFixed(
          4,
      );
      s += ' ';
      if (this.$store.state.app.selectedModelName !== 'National') {
        s += this.$store.state.user.userServerInfo.subscriptions[0][
            'summary_share_perc_text'
            ];
        // ----------
        s += (
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results
                .TW_Share_Prov * 100
        )
            .toFixed(2)
            .toString();
        s += '%';

        return s;
      } else {
        return (s += '');
      }
    },
    get_yes_no(yesno) {
      if (yesno) {
        return '<span class="yes">✓</span>';
      } else {
        return '<span class="no">x&nbsp;</span>';
      }
    },
  },
};
</script>

<style scoped>
.rta_rta_text {
  font-size: 0.78rem;
}
</style>
